module.exports = __webpack_public_path__ + "static/img/yali.795835ce.png";